// BillingPlanCard.js
import { planLabel, planDetails } from '../../utils/billingStatus';

export default function BillingPlanCard({ billing }) {
    const plan = billing?.plan ?? null;
    const { priceMonthly, seatLimit, caseAllowance } = planDetails(plan, billing ?? {});
    return (
        <section className="billing-card">
            <h2 className="billing-card-title">Plan</h2>
            <div className="billing-plan-name">{planLabel(plan)}</div>
            <div className="billing-plan-price">
                {priceMonthly != null ? `$${priceMonthly.toLocaleString()} / month`
                 : plan ? 'Contact billing for pricing'
                 : 'No plan on file'}
            </div>
            <dl className="billing-kv">
                <dt>Seats included</dt><dd>{seatLimit ?? '—'}</dd>
                <dt>Cases per month</dt><dd>{caseAllowance != null ? `${caseAllowance} included` : '—'}</dd>
            </dl>
        </section>
    );
}
